<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1C9.91945 1 8.14095 1.75743 6.66443 3.2723C5.22147 4.75275 4.5 6.56024 4.5 8.69484C4.5 9.76213 4.76845 11.0016 5.30537 12.4131C5.84228 13.8247 6.43792 15.09 7.09228 16.2089C7.74665 17.3279 8.51006 18.4812 9.38255 19.669C10.255 20.8568 10.8591 21.6487 11.1946 22.0446C11.5302 22.4405 12 23 12 23C12 23 12.302 22.7418 12.8054 22.1221C13.3087 21.5023 13.9211 20.6675 14.6426 19.6174C15.3641 18.5673 16.094 17.4398 16.8322 16.2347C17.5705 15.0297 18.1997 13.7387 18.7198 12.3615C19.2399 10.9843 19.5 9.76213 19.5 8.69484C19.5 6.56024 18.7701 4.74414 17.3104 3.24648C15.8507 1.74882 14.0805 1 12 1ZM12 11.3529C11.3082 11.3529 10.7107 11.1088 10.2075 10.6204C9.73585 10.0995 9.5 9.48095 9.5 8.76471C9.5 8.04846 9.74371 7.43803 10.2311 6.93341C10.7186 6.42878 11.3082 6.17647 12 6.17647C12.6918 6.17647 13.2814 6.42878 13.7689 6.93341C14.2563 7.43803 14.5 8.04846 14.5 8.76471C14.5 9.48095 14.2563 10.0914 13.7689 10.596C13.2814 11.1006 12.6918 11.3529 12 11.3529Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PlaceIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
